<template>
  <div class="container">
    <div class="content" id="codeDom">
      <div class="code">
        <div class="code-container">
          <div class="code-user">
            <img class="imgs" :src="$FILE_PATH + detail.cover" @load="onLoadForCover" crossOrigin="anonymous" />
          </div>
          <div class="code-content">
            <div class="code-title">{{ detail.title }}</div>
            <!-- <div class="code-subTitle">{{ detail.subTitle }}</div> -->
            <div class="code-slogan">族谱家族社区</div>
            <img v-if="code" class="code-qrcode" :src="code" />

            <div class="code-tips">
              <div>聚亲APP扫码直接加入</div>
              <div>微信扫码下载APP加入</div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="handle">

      <div class="handle-item" v-clipboard:copy="detail.codeText" v-clipboard:success="onCopy" v-clipboard:error="onError">
        <iain-image-domain w="50" h="50" src="static/img/mine/copy.png" />
        <div class="handle-label handle-label2">复制链接</div>
      </div>

      <div class="handle-item" @click="download">
        <iain-image-domain w="40" h="40" src="static/img/mine/icon15.png" />
        <div class="handle-label">保存</div>
      </div>

      <div class="handle-item" @click="share">
        <iain-image-domain w="40" h="40" src="static/img/mine/icon16.png" />
        <div class="handle-label">分享</div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import html2canvas from 'html2canvas'

export default {
  name: 'UserCode',
  data () {
    return {
      detail: {},

      code: '',
      cover: false,

      codePoster: '',

      Loading: null
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.Loading = this.$toast.loading({ message: '生成二维码中...' })
      const detail = JSON.parse(this.$route.query.query)
      this.detail = detail
      console.log('this.detail, ', this.detail)
      await this.setCode()
      this.getBase64Image(this.$FILE_PATH + this.detail.cover, document.querySelector('.imgs'));
      this.Loading.message = '生成海报中...'
      this.$nextTick(this.generatePoster)
    },

    async setCode () {
      const code = await QRCode.toDataURL(this.detail.codeText, { width: 400, height: 400, margin: 0 })

      if (!code) {
        this.Loading.clear()
        this.$toast.fail(' 生成二维码失败')
        return
      }

      this.code = code
    },

    onLoadForCover () {
      this.cover = true
      this.$nextTick(this.generatePoster);
    },

    getBase64Image (url, ref) {
      var image = new Image();
      image.src = url + "?v=" + Math.random(); // 处理缓存
      image.crossOrigin = "*"; // 支持跨域图片
      const that = this
      image.onload = function () {
        var base64 = that.drawBase64Image(image);
        ref.src = base64;
      };
    },

    drawBase64Image (img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var dataURL = canvas.toDataURL("image/png");
      return dataURL;
    },

    async generatePoster () {
      if (!this.cover || !this.code) return
      const posterCanvas = await html2canvas(document.getElementById('codeDom'), { backgroundColor: null, scale: 2 })
      this.codePoster = posterCanvas.toDataURL('image/png')
      console.log(this.codePoster)
      this.Loading.clear()
    },

    download () {
      uni.postMessage({ data: { type: 'DOWNLOAD', base64: this.codePoster } })
    },

    share () {
      this.generatePoster()
      uni.postMessage({ data: { type: 'SHARE', base64: this.codePoster } })
    },

    onCopy(e) {
      console.log("复制成功！");
      alert("已复制到剪切板！");
    },
    onError(e) {
      console.log("复制失败！");
      alert("抱歉，复制失败！");
    },

  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #f8f8f8;

  .content {
    padding: 170px 95px 95px;
    background-image: url("https://client.kinfriend.com/wap/app/static/img/team/team-post-bg.png");
    background-size: 100% 100%;
    margin-bottom: 60px;
    .code {
      position: relative;

      .code-container {
        padding-top: 76px;
        position: relative;

        .code-user {
          position: absolute;
          top: 0;
          left: 50%;
          z-index: 100;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 152px;
          height: 152px;
          margin-left: -78px;
          border-radius: 50%;
          background: #ffffff;

          img {
            width: 132px;
            height: 132px;
            border-radius: 50%;
          }
        }

        .code-content {
          box-sizing: border-box;
          padding: 100px 60px 20px;
          border-radius: 20px;
          text-align: center;
          // background-color: #ffffff;

          .code-title {
            padding-bottom: 20px;
            font-size: 42px;
            color: #222222;
          }

          .code-subTitle {
            padding-bottom: 20px;
            font-size: 28px;
            color: #9a9a9a;
          }

          .code-slogan {
            font-size: 52px;
            font-weight: bold;
          }

          .code-qrcode {
            margin-top: 30px;
            padding: 30px;
            background-color: #fff;
            width: 328px;
            height: 328px;
          }

          .code-tips {
            margin-top: 20px;
            font-size: 40px;
            line-height: 60px;
          }
        }
      }
    }
  }

  .handle {
    display: flex;
    padding-bottom: 20px;

    .handle-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      flex: 1;

      .handle-label {
        padding-top: 20px;
        color: #000000;
      }
      .handle-label2 {
        padding-top: 15px;
        color: #000000;
      }
    }
  }
}
</style>>

